@if (!element.isFeeAlreadyAdded) {
  <button mat-flat-button color="primary" (click)="addFee.emit(element)">
    Add
  </button>
} @else {
  <div class="used-fee">
    <mat-icon>check_circle</mat-icon>
    <span>Added</span>
  </div>
}
